import { useState } from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  TextFieldProps,
} from "@mui/material";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { useTranslate } from "react-admin";
import styles from "./style";

type PasswordFieldProps = Omit<TextFieldProps, "type">;

const PasswordField = ({ sx, slotProps, ...props }: PasswordFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const translate = useTranslate();

  return (
    <TextField
      {...props}
      type={showPassword ? "text" : "password"}
      variant="outlined"
      fullWidth
      sx={{
        ...styles.input,
        ...sx,
      }}
      slotProps={{
        ...slotProps,
        input: {
          ...slotProps?.input,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword((prev) => !prev)}
                onMouseDown={(e) => e.preventDefault()}
                edge="end"
                aria-label={
                  showPassword
                    ? translate("ra.gameoo.passwordField.hidePassword")
                    : translate("ra.gameoo.passwordField.showPassword")
                }
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default PasswordField;
